import React from "react"
import PropTypes from "prop-types"

import { Link } from "gatsby-plugin-react-i18next"

import PathTransformer from "../parsers/PathTransformer"

import { modalsPathValidator } from "../../helpers/ModalsPathValidator"

import Modal from "../_base/Modal"

const isInternalLink = linkPath => {
  return linkPath && (/^\/(?!\/)/.test(linkPath) || linkPath.startsWith("#"))
}

const relativeLink = (linkPath, pageContext) => {
  if (!pageContext || !pageContext.wordpressUrl) return linkPath

  const indx = linkPath.indexOf(pageContext.wordpressUrl)
  if (indx === 0) return linkPath.substring(pageContext.wordpressUrl.length)

  return linkPath
}

function CubewiseLink(props) {
  let linkPath = props.linkPath || null
  if (!props.isFile) {
    if (linkPath) linkPath = relativeLink(linkPath, props.pageContext)
    if (linkPath && props.translate)
      linkPath = PathTransformer(
        linkPath,
        props.pageContext.language,
        props.pageContext.i18n.defaultLanguage,
        props.pageContext.i18n.languages,
      )
  }
  
  if (linkPath && (!isInternalLink(linkPath) || props.ctaIsFile))
    return (
      <a
        href={linkPath}
        target="_blank"
        rel="noreferrer"
        className={`wp-block-button__link wp-element-button`}
      >
        {props.children}
      </a>
    )

  if (
    linkPath &&
    isInternalLink(linkPath) &&
    !props.ctaIsFile &&
    !modalsPathValidator.validator(linkPath)
  ) {
    if (props.openBlank) {
      const dest =
        typeof window !== "undefined"
          ? `${window.location.protocol}//${window.location.host}${linkPath}`
          : `${linkPath}`
      return (
        <Link
          className={`wp-block-button__link wp-element-button`}
          to={dest}
          target={`_blank`}
          rel="noopener noreferrer"
        >
          {props.children}
        </Link>
      )
    }

    return (
      <Link className={`wp-block-button__link wp-element-button`} to={linkPath}>
        {props.children}
      </Link>
    )
  }

  if (
    linkPath &&
    isInternalLink(linkPath) &&
    !props.ctaIsFile &&
    modalsPathValidator.validator(linkPath)
  )
    return (
      <Modal
        url={linkPath}
        modalsRepo={props.modals}
        brand={props.pageContext.brand}
      >
        {({ handleOpenModal }) => {
          return (
            <a
              href={linkPath}
              className={`wp-block-button__link wp-element-button`}
              onClick={evt => {
                evt.preventDefault()
                handleOpenModal()
              }}
            >
              {props.children}
            </a>
          )
        }}
      </Modal>
    )

  return <></>
}

CubewiseLink.defaultProps = {
  isFile: false,
  openBlank: false,
  translate: true,
}

const PROPTYPES_PROXY = {
  linkPath: PropTypes.string.isRequired,
  isFile: PropTypes.bool.isRequired,
  openBlank: PropTypes.bool.isRequired,
  translate: PropTypes.bool.isRequired,
  pageContext: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
}
CubewiseLink.propTypes = PROPTYPES_PROXY

export default CubewiseLink
